import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { DirectivesModule } from 'directives/directives.module';
import { ViewExercisePage } from './view-exercise-page';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [ViewExercisePage],
    imports: [PagesModule, ComponentsModule, DirectivesModule]
})
export class ViewExercisePageModule { }
